<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <form id="importForm" @submit.prevent="save" v-if="role == 'admin'"></form>
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col-md-7">
          <h3 class="page-title">
            {{
              role == "admin"
                ? "Employees' Insurance and Dependents"
                : "My Insurance and Dependents"
            }}
          </h3>
        </div>
        <div class="col-md-5 float-right ml-auto" v-if="role == 'admin'">
          <div class="text-right">
            <button
              v-if="!isUpload"
              @click="toggleIsUpload"
              class="btn btn-link btn-upload"
            >
              <i class="fa fa-upload"></i> Upload Data
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Upload Section  -->
    <div class="section mb-4" v-if="isUpload">
      <div class="align-items-center" style="margin-top: -7px">
        <div class="col-md-12">
          <input
            @change="onFileSelected($event)"
            type="file"
            accept=".xlsx"
            class="custom-file-input"
            id="excelFile"
            ref="excelFile"
            style="cursor: pointer"
            required
            form="importForm"
          />
          <label
            class="custom-file-label"
            for="excelFile"
            style="cursor: pointer"
            >{{ file ? file.name : "Upload file..." }}</label
          >

          <br />
          <button
            style="margin-left: -20px"
            class="btn btn-sm btn-link mt-2"
            @click="dowloadTemplate"
          >
            Download Template File
          </button>
        </div>
        <div class="col-md-4 pr-0 mt-2">
          <button
            style="margin-left: -10px"
            class="btn btn-sm btn-primary"
            form="importForm"
            :disabled="!file"
          >
            <i class="fa fa-upload"></i> Upload
          </button>

          <button
            v-if="isUpload"
            @click="toggleIsUpload"
            class="btn btn-sm btn-danger"
          >
            <i class="fa fa-times"></i> Cancel
          </button>
        </div>
      </div>
    </div>
    <!-- /Upload Section  -->

    <!-- Error Details  -->
    <div class="row mt-2 mb-5" v-if="errors && errors.length && isUpload">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th colspan="5" class="text-center">Error Details</th>
              </tr>
              <tr>
                <th>No.</th>
                <th>Row</th>
                <th>Cell</th>
                <th>Value</th>
                <th class="text-center">Error</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(error, i) in errors" :key="i">
                <td class="align-middle">{{ i + 1 }}</td>
                <td class="align-middle">{{ error.Row }}</td>
                <td class="align-middle"><div v-html="error.Cell"></div></td>
                <td class="align-middle"><div v-html="error.Value"></div></td>
                <td class="align-middle">
                  <div class="text-danger" v-html="error.Message"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Error Details  -->

    <!-- Single Employee Message -->
    <div class="mt-4" v-if="role != 'admin' && employee && employee.isSingle">
      <div class="col-12 no-record">
        This function is not applicable for staff with Marital Status: Single
      </div>
    </div>
    <!-- /Single Employee Message -->

    <!-- New Employee Message -->
    <div class="mt-4 mb-4" style="padding: 15px 15px 1px; background-color: #FFF;" v-if="role == 'employee' && employee && !employee.isSingle && isNewEmployee">
      <p>
        You are allowed to submit your Insurance and Dependents for this year because your joined year is the same as current year. Once you have submitted your Insurance and Dependents for this year, you are not allowed to make any amendments.
      </p>
      <p>
        <input type="checkbox" v-model="isNewEmployeeConfirm" style="cursor:pointer"> I confirm to submit my Insurance and Dependents for this year and won't be updating anymore.
        <button type="button" :disabled="!isNewEmployeeConfirm" class="btn btn-primary" @click="submit">Submit</button>
      </p>
    </div>
    <!-- /New Employee Message -->

    <insurance-list v-if="role == 'admin' || (employee && !employee.isSingle)" :key="counterInsurance"></insurance-list>
    <dependent-list v-if="role == 'admin' || (employee && !employee.isSingle)" class="mt-4" :key="counterDependent"></dependent-list>

    <!-- Progress Modal -->
    <div class="modal custom-modal fade" id="progressModal" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Import Insurance and Dependents - Progress
            </h5>
          </div>
          <div class="modal-body pt-3">
            <div class="progress mb-3">
              <div
                id="progressBar"
                ref="progressBar"
                :class="[
                  !complete ? 'progress-bar-animated' : '',
                  'progress-bar progress-bar-striped bg-success',
                ]"
                role="progressbar"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="progressBarWidth"
              >
                {{ progressBarText }}
              </div>
            </div>
            <label id="validationStartText">
              Started Validating Records...
            </label>
            <br />
            <label id="validationCompleteText">
              {{ validationCompleteText }}
            </label>
            <br />
            <label id="savingStartText">{{ savingStartText }}</label>
            <label id="savingCompleteText">{{ savingCompleteText }}</label>
            <br />
            <label id="footerText">{{ footerText }}</label>
            <div class="row">
              <div class="col-md-12 text-right">
                <button
                  v-if="complete"
                  data-dismiss="modal"
                  aria-label="Close"
                  class="btn btn-primary"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Progress Modal -->
  </div>
</template>

<script>
import InsuranceList from "./InsuranceList.vue";
import DependentList from "./DependentList.vue";
import * as XLSX from "xlsx";
import API from "../../../http-common.js";

export default {
  components: {
    InsuranceList,
    DependentList,
  },
  data() {
    return {
      file: null,
      errors: [],
      employee: null,
      counterInsurance: 0,
      counterDependent: 1,
      isNewEmployee: false,
      isNewEmployeeConfirm: false,
      //for progress modal
      progressBarWidth: { width: "0%" },
      progressBarText: "",
      validationCompleteText: "",
      savingStartText: "",
      savingCompleteText: "",
      footerText: "",
      complete: false,
      isUpload: false,
      //setting
      titles: [
        { col: "A", title: "Employee ID" },
        { col: "B", title: "Insurance Year" },
        { col: "C", title: "Type of Insurance" },
        { col: "D", title: "Enrolment Category" },
        { col: "E", title: "No. of Children" },
        { col: "F", title: "Dependent Name" },
        { col: "G", title: "Group Dental (Y/N)" },
        { col: "H", title: "Group H&S and MM (Y/N)" },
        { col: "I", title: "Dependent Relationship" },
        { col: "J", title: "Dependent Marital Status" },
        { col: "K", title: "Dependent IC Number" },
        { col: "L", title: "Dependent Nationality" },
        { col: "M", title: "Dependent Gender (M/F)" },
        { col: "N", title: "Dependent Birthday" },
        { col: "O", title: "Is your child on full-time studies? (Y/N)" },
      ],
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  methods: {
    dowloadTemplate() {
      window.open(this.$backendUrl + "/Docs/InsuranceDependentTemplate.xlsx");
    },
    toggleIsUpload() {
      this.isUpload = !this.isUpload;
    },
    reset() {
      this.file = null;
      this.errors = [];
    },
    onFileSelected(e) {
      this.reset();
      this.file = e.target.files[0];
      if (this.file && this.file.name.split(".").pop() == "xlsx") {
        let fileReader = new FileReader();
        fileReader.readAsBinaryString(this.file);
      }
    },

    getEmployeeDetail() {
      let param = { Token: this.token };
      this.$store.state.isLoading = true;
      API.getEmployeeDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {        
            this.employee = response.data.record;
            if ( this.employee.length > 0 ) {
              this.employee = this.employee[0];
            }
            this.isNewEmployee = response.data.isNewEmployee;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    save() {
      //validate file extension;
      if (this.file && this.file.name.split(".").pop() != "xlsx") {
        this.$swal("Please select an xlsx file", { icon: "error" });
        return;
      }
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to import the data?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          //reset
          this.errors = [];
          //process
          let fileReader = new FileReader();
          fileReader.readAsBinaryString(this.file);
          fileReader.onload = (event) => {
            let binaryData = event.target.result;
            //console.log("binaryData", binaryData);
            let workbook = XLSX.read(binaryData, { type: "binary" });
            let data = XLSX.utils.sheet_to_json(
              workbook.Sheets[workbook.SheetNames[0]],
              {
                defval: "",
                header: "A",
                blankrows: true,
              }
            );
            //console.log("data", this.data);

            //validate header and blank row
            if (
              !this.validateHeader(data[0]) ||
              !this.validateBlankRecords(data)
            ) {
              this.$swal("Import failed. Please see error details", {
                icon: "error",
              });
              return;
            }

            //format data before passing to server
            let formattedData = this.format(data);

            //if no error, begin import
            if (!this.errors.length) {
              this.importInsuranceDependentData(formattedData);
            }
          };
          //clear file after upload
          this.file = null;
          this.$refs.excelFile.value = null;
        }
      });
    },

    validateHeader(header) {
      //console.log("header", header);
      let isValid = true;
      for (let item of this.titles) {
        if (
          !header[item.col] ||
          (header[item.col] && header[item.col] != item.title)
        ) {
          isValid = false;
          this.errors.push({
            Row: "1",
            Cell: `${item.col}1`,
            Value: !header[item.col] ? "" : header[item.col],
            Message: `Title must be ${item.title}`,
          });
        }
      }
      return isValid;
    },

    validateBlankRecords(data) {
      let hasBlankRow = false;
      for (let i = 1; i < data.length; i++) {
        let row = data[i];
        let isValid = false;
        for (let item of this.titles) {
          if (row[item.col]) {
            isValid = true;
            break;
          }
        }
        if (!isValid) {
          hasBlankRow = true;
          this.errors.push({
            Row: i + 1,
            Cell: "",
            Value: "",
            Message: "Row cannot be blank",
          });
        }
      }
      return !hasBlankRow;
    },

    format(data) {
      //console.log("data", data);
      let formattedData = [];
      for (let i = 1; i < data.length; i++) {
        let row = data[i];
        let obj = {
          Row: i + 1,
          EmployeeID: row["A"] ? row["A"] : "",
          EmployeeIDCol: "A",
          InsuranceYear: row["B"] ? row["B"] : "",
          InsuranceYearCol: "B",
          InsuranceType: row["C"] ? row["C"] : "",
          InsuranceTypeCol: "C",
          EnrolmentCategory: row["D"] ? row["D"] : "",
          EnrolmentCategoryCol: "D",
          NoOfChildren: row["E"] ? row["E"] : "",
          NoOfChildrenCol: "E",
          DependentName: row["F"] ? row["F"] : "",
          DependentNameCol: "F",
          GroupDental: row["G"] ? row["G"] : "",
          GroupDentalCol: "G",
          GroupHsMm: row["H"] ? row["H"] : "",
          GroupHsMmCol: "H",
          DependentRelationship: row["I"] ? row["I"] : "",
          DependentRelationshipCol: "I",
          DependentMaritalStatus: row["J"] ? row["J"] : "",
          DependentMaritalStatusCol: "J",
          DependentIcNumber: row["K"] ? row["K"] : "",
          DependentIcNumberCol: "K",
          DependentNationality: row["L"] ? row["L"] : "",
          DependentNationalityCol: "L",
          DependentGender: row["M"] ? row["M"] : "",
          DependentGenderCol: "M",
          DependentBirthday: row["N"] ? row["N"] : "",
          DependentBirthdayCol: "N",
          ChildOnFullTimeStudies: row["O"] ? row["O"] : "",
          ChildOnFullTimeStudiesCol: "0",
        };
        formattedData.push(obj);
      }
      return formattedData;
    },

    importInsuranceDependentData(data) {
      let param = { Token: this.token, Data: data };
      this.$store.state.isLoading = true;
      API.importInsuranceDependentData(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.$swal(response.data.message, { icon: "success" });
            //refresh insurance and dependent list table
            this.counterInsurance++;
            this.counterDependent++;
          } else {
            this.$swal(response.data.message, { icon: "error" });
            this.errors = response.data.errors;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    submit(){
      let param = { 
        Token: this.token,  
        IsNewEmployeeSubmitConfirm: this.isNewEmployeeConfirm
      }
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to submit the records?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.submitNewEmployeeInsuranceDependent(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              if (response.data.success) {
                this.$swal(response.data.message, { icon: "success" });
                //refresh insurance and dependent list table
                this.getEmployeeDetail();
                this.counterInsurance++;
                this.counterDependent++;
              } else {
                this.$swal(response.data.message, { icon: "error" });
                this.errors = response.data.errors;
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });      
    }
  },
  created() {
    this.getEmployeeDetail();
  }
};
</script>

<style scoped>
.btn-link {
  color: #007bff;
}
</style>


// WEBPACK FOOTER //
// src/components/Insurance/InsuranceAndDependent/Layout.vue